import cx from 'classnames';
import i18next from 'i18next';

import { updateDontShowConfirmationOnChart } from 'actions/placeorder';
import { dontShowConfirmationOnChartCheckedSelector } from 'selectors/placeOrderSelector';
import { useAppDispatch, useAppSelector } from 'storeHooks';
import MuiCheckBox from 'UIKit/MuiCheckBox';

import styles from './Modals.module.scss';

const dontShowAgainLabel = i18next.t('trading:dontShowAgainForChart');

const DontShowConfirmationForChartPage = () => {
  const dispatch = useAppDispatch();
  const checked = useAppSelector(dontShowConfirmationOnChartCheckedSelector);

  const handleCheck = () => {
    dispatch(updateDontShowConfirmationOnChart(!checked));
  };

  return (
    (<div
      className={cx(
        'flex--align-items-center',
        styles.checkboxRow,
        styles.check,
        styles.onlyShowForMobile
      )}
      data-palette="DontShowConfirmationForChartPage">
      <div className="col-2" data-testid="dontShowAgainCheckbox">
        <MuiCheckBox
          name="donShowConfirmation"
          id="donShowConfirmation"
          checked={checked}
          onChange={handleCheck}
          data-testid="donShowConfirmationCheckbox"
        />
      </div>
      <div
        aria-hidden="true"
        data-testid="dontShowAgainButton"
        onClick={handleCheck}
        className={cx('col-22', styles.dontValue)}
      >
        {dontShowAgainLabel}
      </div>
    </div>)
  );
};

export default DontShowConfirmationForChartPage;
